<div>

  <mat-tab-group>
    <mat-tab label="Testimonial">
      <mat-form-field class="pe-se-input">
        <mat-label>Header</mat-label>
        <input matInput
               [(ngModel)]="item.data.header">
      </mat-form-field>
      <mat-form-field class="pe-se-input">
        <mat-label>Description</mat-label>
        <textarea matInput
                  [(ngModel)]="item.data.description">
        </textarea>
      </mat-form-field>
      <div class="pe-se-testimonial" *ngFor="let testimonial of item.data.list;index as testimonialIndex" >

        <span class="fa fa-times pe-se-remove" (click)="removeTestimonial(testimonialIndex)"></span>
        <mat-form-field class="pe-se-input">
          <mat-label>Name</mat-label>
          <input matInput
                 [(ngModel)]="testimonial.name">
        </mat-form-field>
        <mat-form-field class="pe-se-input">
          <mat-label>Text</mat-label>
          <textarea matInput
                    [(ngModel)]="testimonial.text">
        </textarea>
        </mat-form-field>
        <div class='pe-se-input pe-se-file' >
          <input type='file' (change)="selectFileToTestimonial($event,testimonialIndex)"  accept="image/*">
          <img alt="background Image" [attr.src]="imageSelector(testimonial.image)" />
        </div>
      </div>
      <div class="pe-se-testimonial">
        <span class="fa fa-plus pe-se-add" (click)="addItemTestimonialInList()"></span>
      </div>
    </mat-tab>

    <mat-tab label="Layout">
      <app-sub-layout-setting [item]="item" [layoutSetting]="layoutSetting"></app-sub-layout-setting>
    </mat-tab>
  </mat-tab-group>

</div>

